import * as ResponsiveFns from '../utilities/ResponsiveFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
import * as EditorFunctions from '../utilities/EditorFunctions';
import * as CoreFns from '../utilities/CoreFns';
import OwnColor from './OwnColor';
import FontSelector from './FontSelector';
import DistanceSelector from '../StockItems/DistanceSelector';
import DoGuide from '../Tabs/DoGuide';

function App(props) {

  var itemEdited = props.itemEdited;
  var organicChanges = props.organicChanges;
  var currentList = props.currentList;
  var refObject = props.refObject;
  var anItem = props.anItem;
  var toggle = props.toggle;
  var setToggle = props.setToggle;
  var insetWidth = props.insetWidth;
  var insetHeight = props.insetHeight;
  var screenSize = props.screenSize;
  var userID = props.userID;
  var mostRecentFont = props.mostRecentFont;
  var setMostRecentFont = props.setMostRecentFont;
  var isShowingSomeDropDown = props.isShowingSomeDropDown;
  var columnWidth = props.columnWidth;
  var mostRecentColor = props.mostRecentColor;
  var setMostRecentColor = props.setMostRecentColor;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var addToExtraScreen = props.addToExtraScreen;

  var itemPath = itemEdited.path;
  var sel = document.getSelection();
  var inlines5 = EditorFunctions.getInlinesOfANode(sel.anchorNode, itemPath);
  var doInputActions = ResponsiveFns.doInputActionsFn(itemPath, organicChanges, currentList, userID);
  var ref1 = refObject[itemPath.join('_')];

  function onMouseDown(e){
    e.preventDefault();
  }

  if (anItem.t === 'fontSize'){

    var fontSize = 1;
    var possibleUnits = StyleFunctions.fontWidthPieces(false);
    var fontUnit = 'em';
    for (var i = 0; i < inlines5.length; i++){
      var thisInline = inlines5[i];
      if (thisInline.t === 'F'){
        var v = thisInline.v;
        if (v){
          if (v.indexOf('calc') === 0){
            fontUnit = 'comb';
            var inside = v.substr(5, v.length - 6);
            var insideArray = inside.split(' + ');
            fontSize = {};

            var v2 = insideArray[0];
            var ss2 = v2.indexOf('px');
            if (ss2 > 0){
              fontSize.fixed = +v2.substr(0, ss2);
            }

            for (var j1 = 0; j1 < possibleUnits.length; j1++){
              var v1 = insideArray[1];
              var ss1 = v1.indexOf(possibleUnits[j1].t);
              if (ss1 > 0){
                fontSize.var = {t:possibleUnits[j1].t, v:+v1.substr(0, ss1)};
                break;
              }
            }
            // console.log(fontSize);
          }else{
            for (var j = 0; j < possibleUnits.length; j++){
              var ss = v.indexOf(possibleUnits[j].t);
              if (ss > 0){
                fontSize = v.substr(0, ss);
                fontUnit = possibleUnits[j].t;
                break;
              }

            }

          }
        }

      }
    }

    function submitValueAndUnit(set){
      var unit = set.t;
      var value = set.v;
      var newFontSize;
      if (unit === 'comb'){
        var variable = value.var;
        var varPiece = variable.v + variable.t;
        var fixed = value.fixed + 'px';
        newFontSize = 'calc('+fixed + ' + '+ varPiece + ')';
      }else{
        newFontSize = value + unit;
      }
      EditorFunctions.toggleBIU({t:'F',v:newFontSize}, false, doInputActions, ref1, itemEdited.path, toggle, setToggle, insetWidth, insetHeight)();

    }
// 
    return (<td onMouseDown={onMouseDown}><center>
        <DistanceSelector title={'Font Size'} changeWhat={anItem.t} origDistance={fontSize} step={0.01} min={0.01} max={100} uintChoices={possibleUnits} origUnit={fontUnit} submitValueAndUnit={submitValueAndUnit} insetWidth={insetWidth} insetHeight={insetHeight} doCombo={true} screenSize={screenSize}/>

        </center></td>)
//
  }else if (anItem.t === 'fontFamily'){

      function clickFontFamily(g){
        var sel = document.getSelection();
        EditorFunctions.toggleBIU({t:'G',v:g}, false, doInputActions, ref1, itemEdited.path, toggle, setToggle, insetWidth, insetHeight)();
        var range = document.createRange();
        range.setStart(sel.anchorNode, sel.anchorOffset);
        range.setEnd(sel.focusNode, sel.focusOffset);
        sel.removeAllRanges()
        sel.addRange(range);
      }
//
      var currentFont = '';
      for (var i6 = 0; i6 < inlines5.length; i6++){
        var thisInline6 = inlines5[i6];
        if (thisInline6.t === 'G'){
          currentFont = thisInline6.v;
          break;
        }
      }

      return (<td>
        <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'fontFamily'}} />
        <FontSelector clickFontFamily={clickFontFamily} currentFont={currentFont} mostRecentFont={mostRecentFont} setMostRecentFont={setMostRecentFont}/></td>);

//
  }else if (anItem.t === 'fontColor'){
    function clickColor(newColor){
      var sel = document.getSelection();
      EditorFunctions.toggleBIU({t:isShowingSomeDropDown.v, v:newColor}, false, doInputActions, ref1, itemEdited.path, toggle, setToggle, insetWidth, insetHeight)();
      var range = document.createRange();
      range.setStart(sel.anchorNode, sel.anchorOffset);
      range.setEnd(sel.focusNode, sel.focusOffset);
      sel.removeAllRanges()
      sel.addRange(range);
    }

    var styleL = {color:'white', cursor:'pointer'};
    var styleR = {color:'white', cursor:'pointer'};
    if (isShowingSomeDropDown.v === 'C'){
      styleL.textDecoration = 'underline';
    }else{
      styleR.textDecoration = 'underline';
    }
    
    function clickL(v){
      return function(e){
        setIsShowingSomeDropDown({t:'color', v});
        e.stopPropagation();
      }
    }
    var origColor = '';
    var toggleToGradient;
    var secondaryColor;
    var firstColor;

    if (isShowingSomeDropDown){
      var vv5 = isShowingSomeDropDown.v;
      for (var i5 = 0; i5 < inlines5.length; i5++){
        if (inlines5[i5].t === vv5){
          origColor = inlines5[i5];
        }
      }

      var colorType;
      if (vv5 === 'C'){
        colorType = 'color';
      }

      var currentScreenStyle = CoreFns.goDownPath(currentList, itemPath.concat(['s']));

      firstColor = <OwnColor submitColor={clickColor} currentStyle={origColor} currentList={currentList} allowFormula={false} e={false} hideHEX={true} width={columnWidth - 20} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor} colorType={colorType} logPath={itemPath.concat(['s'])} organicChanges={organicChanges} styles={currentScreenStyle} />;

      if (vv5 === 'C'){

        if (origColor && origColor.v && origColor.v.indexOf('linear-gradient') === 0){
          function switchToToggle1(e){
            clickColor('rgb(144, 101, 101)');
          }
          var fatPiece = origColor.v.split('linear-gradient(')[1];
          var pieces = fatPiece.split('rgb(');
          var priorPiece = 'linear-gradient(' + pieces[0];
          var firstPieceBeforeCloseBrack = pieces[1].split(')')[0];
          var firstPiece = 'rgb(' + firstPieceBeforeCloseBrack + ')';

          var secondPieceBeforeCloseBrack = pieces[2].split(')')[0];
          var secondPiece = 'rgb(' + secondPieceBeforeCloseBrack + ')';


          function clickColor1(newColor){
            clickColor(priorPiece + newColor + ', ' + secondPiece + ')');
          }

          firstColor = <OwnColor submitColor={clickColor1} currentStyle={{t:'C', v:firstPiece}} currentList={currentList} allowFormula={false} e={false} hideHEX={true} width={columnWidth - 20} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor}/>;              

          function clickColor2(newColor){
            clickColor(priorPiece + firstPiece + ', ' + newColor + ')');
          }

          secondaryColor = <OwnColor submitColor={clickColor2} currentStyle={{t:'C', v:secondPiece}} currentList={currentList} allowFormula={false} e={false} hideHEX={true} width={columnWidth - 20} mostRecentColor={mostRecentColor} setMostRecentColor={setMostRecentColor}/>;              


          toggleToGradient = <span onMouseDown={onMouseDown} onClick={switchToToggle1} style={{cursor:'pointer'}}>[Remove Color Gradient]</span>
//
        }else{
          function switchToToggle(e){
            clickColor('linear-gradient(60deg, #E21143, #FFB03A)');
          }
          toggleToGradient = <span onMouseDown={onMouseDown} onClick={switchToToggle} style={{cursor:'pointer'}}>[Add Color Gradient]</span>

        }
//
      }
    }


    
    return (<td onMouseDown={onMouseDown}>
        <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'fontColor'}} />
              <center>
            <div><span onMouseDown={onMouseDown} onClick={clickL('C')} style={styleL}><b>Text</b></span>&nbsp;&nbsp;&nbsp;<span onMouseDown={onMouseDown} onClick={clickL('D')} style={styleR}><b>Highlight</b></span></div>

            {firstColor}
            {secondaryColor}
            {toggleToGradient}
            </center></td>)
//        
  }

}




//
export default App;
